/* eslint-disable */
/* fr_CA Static Templates Data */

const BakeryEmailData = {
  styles: {
    width: '600px',
    color: '#898989',
    backgroundColor: '#fff',
    couponBorderColor: '#00aeef',
    buttonsDividersColor: '#898989',
    sicailLinksColor: '#00aeef',
  },
  components: [
    {
      type: 'image',
      image: '472/bakery-email-logo_1498080292703.png',
    },
    {
      type: 'image',
      image: 'em-email-images/CA-FR/Bakery-Template-CA-FR.png',
    },
    {
      type: 'text',
      text: '<h2 class="ql-align-center">10 % DE RABAIS SUR VOTRE PROCHAIN ACHAT</h2>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">On voulait simplement vous envoyer un petit cadeau pour vous dire merci. N’hésitez pas à utiliser ce coupon lors de votre prochaine visite à La Boulangerie Bob, où tout est préparé sur place, à partir de zéro, avec seulement les ingrédients les plus frais. Passez chercher une commande pour emporter ou installez-vous pour savourer l’un de nos nombreux gâteaux et tartes fraîchement cuits. Au plaisir de vous voir bientôt !</p>',
    },
    {
      type: 'coupon',
      text: '<h2 class="ql-align-center">10 % DE RABAIS SUR VOTRE PROCHAIN ACHAT</h2><p class="ql-align-center" style="font-size: 10px;">Limite d’une offre par client. Ne peut être jumelée à aucun autre coupon ou offre. Nul là où interdit. Taxes de vente en sus. Aucune valeur monétaire.</p>',
    },
    {
      type: 'divider',
    },
    {
      type: 'social',
      links: {
        facebook_link: 'https:www.facebook.com/',
        twitter_link: 'https:twitter.com/',
        youtube_link: 'https:www.youtube.com/',
      },
    },
  ],
};

const BarPubEmailData = {
  styles: {
    width: '600px',
    color: '#fff',
    backgroundColor: '#898989',
    couponBorderColor: '#fff',
    buttonsDividersColor: '#fff',
    sicailLinksColor: '#fff',
  },
  components: [
    {
      type: 'image',
      image: '472/bar-pub-email-logo_1498080596725.png',
    },
    {
      type: 'image',
      image: 'em-email-images/CA-FR/Bar-Pub-Template-CA-FR.png',
    },
    {
      type: 'text',
      text: '<h2 class="ql-align-center">HEUREUX HEURE TOUS LES JOURS</h2>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center" style="font-weight: bold;">Täglich von 16:00 bis 19:00 Uhr</p>',
    },
    {
      type: 'spacer',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">Tous les jours de 16h à 19h</p>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">Notre sélection de bières en fût change chaque semaine. Passez nous voir pour découvrir ce qu’on vous propose aujourd’hui!</p>',
    },
    {
      type: 'spacer',
    },
    {
      type: 'coupon',
      text: '<h4 class="ql-align-center">1 $ DE RABAIS SUR UN ARTICLE DE L’HEURE JOYEUSE</h4><p class="ql-align-center">limite d’un article</p><br><p class="ql-align-center" style="font-size: 10px;">Limite d’une offre par client. Ne peut être jumelée à aucun autre coupon ou offre. Nul là où interdit. Taxes de vente en sus. Aucune valeur monétaire.</p><br>',
    },
    {
      type: 'divider',
    },
    {
      type: 'social',
      links: {
        facebook_link: 'https:www.facebook.com/',
        twitter_link: 'https:twitter.com/',
        youtube_link: 'https:www.youtube.com/',
      },
    },
  ],
};

const BurgerEmailData = {
  styles: {
    width: '600px',
    backgroundColor: '#e11b22',
    color: '#fff',
    headingsColor: '#fff',
    buttonsDividersColor: '#fff',
  },
  components: [
    {
      type: 'image',
      image: 'em-email-images/CA-FR/Burger-Template-CA-FR.png',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">À L’ACHAT D’UN REPAS COMBO, OBTENEZ-EN UN GRATUIT.</p>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">Notre galette de bœuf assaisonnée, 100 % bœuf américain, servie avec des légumes frais et du bacon fumé est là pour rester! Accompagnez votre commande d’une bière artisanale bien froide et commencez votre semaine avec le sourire!</p>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">Montrez ce coupon à votre serveur ou imprimez-le.</p>',
    },
    {
      type: 'coupon',
      text: '<h2 class="ql-align-center">À L’ACHAT D’UN REPAS COMBO, OBTENEZ-EN UN GRATUIT</h2><p class="ql-align-center">(de valeur égale ou moindre)</p><p class="ql-align-center">Limite d’une offre par client. Ne peut être jumelée à aucun autre coupon ou offre. Nul là où interdit. Taxes de vente en sus. Aucune valeur monétaire.</p>',
    },
    {
      type: 'divider',
    },
    {
      type: 'social',
      links: {
        facebook_link: 'https:www.facebook.com/',
        twitter_link: 'https:twitter.com/',
        youtube_link: 'https:www.youtube.com/',
      },
    },
  ],
};

const ChineseEmailData = {
  styles: {
    width: '600px',
    color: '#fff',
    backgroundColor: '#231f20',
    couponBorderColor: '#fff',
    buttonsDividersColor: '#fff',
    sicailLinksColor: '#fff',
  },
  components: [
    {
      type: 'image',
      image: '472/chinese-email-logo_1498080685909.png',
    },
    {
      type: 'image',
      image: 'em-email-images/CA-FR/Chinese-Template-CA-FR.png',
    },
    {
      type: 'text',
      text: '<h2 class="ql-align-center" style="font-style:italic;">ROULEAUX IMPÉRIAUX GRATUITS!</h2>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">ou remplacez-les par deux rouleaux de printemps (2)</p>',
    },
    {
      type: 'spacer',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">Découvrez nos spéciaux sur les boissons ainsi que notre menu mis à jour.</p>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">Appelez à l’avance pour faire une réservation dès aujourd’hui!</p>',
    },
    {
      type: 'coupon',
      text: '<h4 class="ql-align-center">ROULEAUX IMPÉRIAUX GRATUITS</h4><br><p class="ql-align-center">ou remplacez-les par deux rouleaux de printemps (2)</p><br><p class="ql-align-center" style="font-size: 10px;">Limite d’une offre par client. Ne peut être jumelée à aucun autre coupon ou offre. Nul là où interdit. Taxes de vente en sus. Aucune valeur monétaire.</p>',
    },
    {
      type: 'divider',
    },
    {
      type: 'social',
      links: {
        facebook_link: 'https:www.facebook.com/',
        twitter_link: 'https:twitter.com/',
        youtube_link: 'https:www.youtube.com/',
      },
    },
  ],
};

const CoffeeEmailData = {
  styles: {
    width: '600px',
    backgroundColor: '#e6e7e8',
    color: '#000',
    headingsColor: '#000',
    buttonsDividersColor: '#000',
  },
  components: [
    {
      type: 'image',
      image: '483/top_1497255967016.png',
    },
    {
      type: 'image',
      image: 'em-email-images/CA-FR/Coffee-Template-CA-FR.png',
    },
    {
      type: 'spacer',
    },
    {
      type: 'text',
      text: '<h3 class="ql-align-center">RÉVEILLEZ-VOUS AVEC NOTRE NOUVEL ARÔME DE CAFÉ RÉCENTEMENT TORRÉFIÉ!</h3>',
    },
    {
      type: 'spacer',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">Il n’y a pas de meilleure façon de commencer la journée que notre tout nouveau café fraîchement torréfié. Corsé et riche en saveur, il vous laissera assurément le sourire aux lèvres. Venez nous voir aujourd’hui et goûtez un échantillon gratuit!</p>',
    },
    {
      type: 'coupon',
      text: '<h4 class="ql-align-center">PRODUITS DE BOULANGERIE FRAIS TOUS LES JOURS</h4><h3 class="ql-align-center">SPÉCIAUX POUR LE DÎNER DU LUNDI AU VENDREDI</h3><p class="ql-align-center">Varie selon l’emplacement du magasin.</p>',
    },
    {
      type: 'divider',
    },
    {
      type: 'social',
      links: {
        facebook_link: 'https:www.facebook.com/',
        twitter_link: 'https:twitter.com/',
        youtube_link: 'https:www.youtube.com/',
      },
    },

  ],
};

const DessertEmailData = {
  styles: {
    width: '600px',
    color: '#464646',
    backgroundColor: '#dfd',
    couponBorderColor: '#ff7d52',
    buttonsDividersColor: '#ff7d52',
    sicailLinksColor: '#464646',
  },
  components: [
    {
      type: 'image',
      image: '472/dessert-email-logo_1498080768821.png',
    },
    {
      type: 'image',
      image: 'em-email-images/CA-FR/Dessert-Template-CA-FR.png',
    },
    {
      type: 'text',
      text: '<h2 class="ql-align-center" style="color:#ff7d52; font-style:italic;">LES NOUVEAUX ÉLÉMENTS DU MENU SONT ARRIVÉS!</h2>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">Le printemps est enfin là, et notre nouveau menu aussi!</p>',
    },
    {
      type: 'spacer',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">Passez nous voir à tout moment cette semaine pour obtenir 50 % de rabais sur tout nouvel item du menu.</p>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">Vous y trouverez de jolis macarons roses, des cake pops aux carottes et fromage à la crème, des barres limonade-fraise, et bien plus encore.</p>',
    },
    {
      type: 'coupon',
      text: '<h4 class="ql-align-center">50 % DE RABAIS SUR LES NOUVEAUX ÉLÉMENTS DU MENU!</h4><p class="ql-align-center">(Cette semaine seulement)</p><br><p class="ql-align-center" style="font-size: 10px;">Ne peut être jumelé à aucun autre coupon ou offre. Nul là où interdit. Taxes de vente en sus. Aucune valeur monétaire.</p>',
    },
    {
      type: 'divider',
    },
    {
      type: 'social',
      links: {
        facebook_link: 'https:www.facebook.com/',
        twitter_link: 'https:twitter.com/',
        youtube_link: 'https:www.youtube.com/',
      },
    },
  ],
};

const DinerEmailData = {
  styles: {
    width: '600px',
    color: '#f00',
    backgroundColor: '#fff',
    couponBorderColor: '#f00',
    buttonsDividersColor: '#f00',
    sicailLinksColor: '#f00',
  },
  components: [
    {
      type: 'image',
      image: '472/diner-email-logo_1498081690316.png',
    },
    {
      type: 'image',
      image: 'em-email-images/CA-FR/Diner-Template-CA-FR.png',
    },
    {
      type: 'text',
      text: '<h2 class="ql-align-center">10 % DE RABAIS SUR VOTRE PROCHAIN ACHAT</h2>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">Venez pour la nourriture, restez pour l’ambiance relaxante! Chez Dave’s Diner, offrir un service avec le sourire est toujours notre priorité.</p>',
    },
    {
      type: 'spacer',
    },
    {
      type: 'spacer',
    },
    {
      type: 'coupon',
      text: '<h2 class="ql-align-center">10 % DE RABAIS SUR VOTRE PROCHAIN ACHAT</h2><p class="ql-align-center" style="font-size: 10px;">Limite d’une offre par client. Ne peut être jumelée à aucun autre coupon ou offre. Nul là où interdit. Taxes de vente en sus. Aucune valeur monétaire.</p>',
    },
    {
      type: 'divider',
    },
    {
      type: 'social',
      links: {
        facebook_link: 'https:www.facebook.com/',
        twitter_link: 'https:twitter.com/',
        youtube_link: 'https:www.youtube.com/',
      },
    },
  ],
};

const FamilyDiningEmailData = {
  styles: {
    width: '600px',
    color: '#fff',
    backgroundColor: '#fc702e',
    couponBorderColor: '#fff',
    buttonsDividersColor: '#fff',
    sicailLinksColor: '#000',
  },
  components: [
    {
      type: 'image',
      image: '472/family-dining-email-2-logo_1498081751965.png',
    },
    {
      type: 'image',
      image: 'em-email-images/CA-FR/Family-Dining-Template-CA-FR.png',
    },
    {
      type: 'text',
      text: '<h2 class="ql-align-center" style="font-style:italic;">LES MARDIS, LES ENFANTS MANGENT GRATUITEMENT!</h2>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">L’heure du souper, c’est un moment en famille chez Crosby’s Kitchen. Venez n’importe quel mardi, et les enfants mangent gratuitement à l’achat d’un plat principal pour adulte.</p>',
    },
    {
      type: 'spacer',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">On vous garantit un repas que vous et vos tout-petits allez adorer.</p>',
    },
    {
      type: 'coupon',
      text: '<h4 class="ql-align-center">UN REPAS POUR ENFANT GRATUIT!</h4><p class="ql-align-center">(à l’achat d’un plat principal pour adulte)</p><br><p class="ql-align-center" style="font-size: 10px;">Ne peut être jumelé à aucun autre coupon ou offre. Nul là où interdit. Taxes de vente en sus. Aucune valeur monétaire.</p>',
    },
    {
      type: 'divider',
    },
    {
      type: 'social',
      links: {
        facebook_link: 'https:www.facebook.com/',
        twitter_link: 'https:twitter.com/',
        youtube_link: 'https:www.youtube.com/',
      },
    },
  ],
};

const FineDiningEmailData = {
  styles: {
    width: '600px',
    backgroundColor: '#f5f3ef',
    color: '#000',
    couponBorderColor: '#770e1f',
    buttonsDividersColor: '#770e1f',
    sicailLinksColor: '#000',
  },
  components: [
    {
      type: 'image',
      image: '472/fine-dining-email-logo_1498081793107.png',
    },
    {
      type: 'image',
      image: 'em-email-images/CA-FR/Fine-Dining-Template-CA-FR.png',
    },
    {
      type: 'text',
      text: '<h2 class="ql-align-center" style="font-style:italic; color:#770e1f;">VOUS ÊTES INVITÉ!</h2>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">Joignez-vous à nous pour une expérience d’accords mets et vins offerte exclusivement à nos clients les plus fidèles.</p>',
    },
    {
      type: 'spacer',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center" style="font-weight:bold;">Menu dégustation à 75 $</p>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">(comprend un repas de 4 services avec accords mets et vins)</p>',
    },
    {
      type: 'coupon',
      text: '<h4 class="ql-align-center" style="font-weight:normal;">RSVP ICI pour participer à cet événement spécial.</h4><p class="ql-align-center" style="font-style:italic;">Faites vite, les places sont limitées!</p><br><p class="ql-align-center" style="font-size: 10px;">Ne peut être jumelé à aucun autre coupon ou offre. Nul là où interdit. Taxes de vente en sus. Aucune valeur monétaire.</p>',
    },
    {
      type: 'divider',
    },
    {
      type: 'social',
      links: {
        facebook_link: 'https:www.facebook.com/',
        twitter_link: 'https:twitter.com/',
        youtube_link: 'https:www.youtube.com/',
      },
    },
  ],
};

const FruitEmailData = {
  styles: {
    width: '600px',
    color: '#f00',
    backgroundColor: '#fff',
    couponBorderColor: '#f00',
    buttonsDividersColor: '#f00',
    sicailLinksColor: '#f00',
  },
  components: [
    {
      type: 'image',
      image: '472/fruit-email-logo_1498081891611.png',
    },
    {
      type: 'image',
      image: 'em-email-images/CA-FR/Fruit-Template-CA-FR.png',
    },
    {
      type: 'text',
      text: '<h2 class="ql-align-center">10 % DE RABAIS SUR VOTRE PREMIÈRE LIVRAISON</h2>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">Nos fruits sont garantis frais ! Faites le plein de collations santé pour vous et vos amis.Nos paniers de fruits feront sourire tout le monde à coup sûr.</p>',
    },
    {
      type: 'spacer',
    },
    {
      type: 'spacer',
    },
    {
      type: 'coupon',
      text: '<h2 class="ql-align-center">10 % DE RABAIS SUR VOTRE PREMIÈRE LIVRAISON.</h2><p class="ql-align-center" style="font-size: 10px;">Limite d’une offre par client. Ne peut être jumelée à aucun autre coupon ou offre. Nul là où interdit. Taxes de vente en sus. Aucune valeur monétaire.</p>',
    },
    {
      type: 'divider',
    },
    {
      type: 'social',
      links: {
        facebook_link: 'https:www.facebook.com/',
        twitter_link: 'https:twitter.com/',
        youtube_link: 'https:www.youtube.com/',
      },
    },
  ],
};

const ItalianEmailData = {
  styles: {
    width: '600px',
    color: '#000',
    backgroundColor: '#fcefd8',
    couponBorderColor: '#d82c1f',
    buttonsDividersColor: '#d82c1f',
    sicailLinksColor: '#000',
  },
  components: [
    {
      type: 'image',
      image: '472/italian-email-logo_1498081923428.png',
    },
    {
      type: 'image',
      image: 'em-email-images/CA-FR/Italian-Template-CA-FR.png',
    },
    {
      type: 'text',
      text: '<h2 class="ql-align-center" style="font-style:italic; color:#d82c1f;">PROFITEZ DE 10 $ DE RABAIS SUR VOTRE PROCHAINE VISITE!</h2>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">De notre penne carbonara à notre célèbre pomodoro bolognaise, vous êtes certain de savourer un repas fantastique.</p>',
    },
    {
      type: 'spacer',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">Montrez-nous ce courriel et recevez 10 $ de rabais sur votre addition. </p>',
    },
    {
      type: 'coupon',
      text: '<h4 class="ql-align-center" style="color:#d82c1f;">10 $ DE RABAIS SUR VOTRE PROCHAINE VISITE</h4><br><p class="ql-align-center" style="font-size: 10px;">Ne peut être jumelé à aucun autre coupon ou offre. Nul là où interdit. Taxes de vente en sus. Aucune valeur monétaire.</p>',
    },
    {
      type: 'divider',
    },
    {
      type: 'social',
      links: {
        facebook_link: 'https:www.facebook.com/',
        twitter_link: 'https:twitter.com/',
        youtube_link: 'https:www.youtube.com/',
      },
    },
  ],
};

const MexicanEmailData = {
  styles: {
    width: '600px',
    color: '#fff',
    backgroundColor: '#efae2a',
    couponBorderColor: '#fff',
    buttonsDividersColor: '#fff',
    sicailLinksColor: '#fff',
  },
  components: [
    {
      type: 'image',
      image: '472/mexican-email-logo_1498082003319.png',
    },
    {
      type: 'image',
      image: 'em-email-images/CA-FR/Mexican-Template-CA-FR.png',
    },
    {
      type: 'text',
      text: '<h2 class="ql-align-center">10 % DE RABAIS SUR VOTRE PROCHAIN ACHAT</h2>',
    },
    {
      type: 'text',
      text: `<p class="ql-align-center">"Notre menu authentique, fait maison, est garanti pour égayer votre journée! Joignez-vous à nous pour savourer une boisson bien fraîche et de délicieux hors-d'œuvre à des prix imbattables.Que la fiesta commence!"</p>`,
    },
    {
      type: 'spacer',
    },
    {
      type: 'coupon',
      text: '<h2 class="ql-align-center">10 % DE RABAIS SUR VOTRE PROCHAIN ACHAT Limite d’une offre par client. Ne peut être jumelée à aucun autre coupon ou offre. Nul là où interdit. Taxes de vente en sus. Aucune valeur monétaire.</p>',
    },
    {
      type: 'divider',
    },
    {
      type: 'social',
        links: {
        facebook_link: 'https:www.facebook.com/',
          twitter_link: 'https:twitter.com/',
          youtube_link: 'https:www.youtube.com/',
      },
    },
  ],
};

const MoveItSportsEmailData = {
  styles: {
    width: '600px',
    color: '#000',
    backgroundColor: '#fff',
    buttonsDividersColor: '#000',
    sicailLinksColor: '#0779be',
  },
  components: [
    {
      type: 'social',
      links: {
        facebook_link: 'https:www.facebook.com/',
        twitter_link: 'https:twitter.com/',
        youtube_link: 'https:www.youtube.com/',
      },
    },
    {
      type: 'spacer',
    },
    {
      type: 'text',
      text: '<h1 class="ql-align-center" style="color:#0779be; font-style:italic;">Vous allez loin.</h1>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">Découvrez aussi nos spéciaux sur les boissons et notre menu mis à jour.</p>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center" style="font-style:italic; font-weight:bold;">Appelez à l’avance pour faire une réservation dès aujourd’hui!</p>',
    },
    {
      type: 'spacer',
    },
    {
      type: 'image',
      image: 'em-email-images/CA-FR/Move-it-Sports-Template-CA-FR.png',
    },
  ],
};

const PizzaEmailData = {
  styles: {
    width: '600px',
    color: '#000',
    backgroundColor: '#fdd85c',
    couponBorderColor: '#eb6464',
    buttonsDividersColor: '#eb6464',
    sicailLinksColor: '#000',
  },
  components: [
    {
      type: 'image',
      image: '472/pizza-email-logo_1498082059029.png',
    },
    {
      type: 'image',
      image: 'em-email-images/CA-FR/Pizza-Template-CA-FR.png',
    },
    {
      type: 'text',
      text: '<h2 class="ql-align-center" style="font-style:italic">À L’ACHAT D’UNE PIZZA, OBTENEZ-EN UNE GRATUITE !</h2>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">Champignons et pepperoni, olives et anchois — le choix vous appartient.Commandez une pizza avec deux garnitures et obtenez-en une GRATUITE !</p>',
    },
    {
      type: 'spacer',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">Montrez-nous ce courriel en magasin ou en ligne pour profiter de cette offre.</p>',
    },
    {
      type: 'coupon',
      text: '<h3 class="ql-align-center">À L’ACHAT D’UNE PIZZA, OBTENEZ-EN UNE GRATUITE !</h3><p class="ql-align-center">(de valeur égale ou moindre)</p><br><p class="ql-align-center" style="font-size: 10px;">Ne peut être jumelée à aucun autre coupon ou offre. Nul là où interdit. Taxes de vente en sus. Aucune valeur monétaire.</p>',
    },
    {
      type: 'divider',
    },
    {
      type: 'social',
      links: {
        facebook_link: 'https:www.facebook.com/',
        twitter_link: 'https:twitter.com/',
        youtube_link: 'https:www.youtube.com/',
      },
    },
  ],
};

const QsrEmailData = {
  styles: {
    width: '600px',
    color: '#000',
    backgroundColor: '#fff',
    couponBorderColor: '#000',
    buttonsDividersColor: '#000',
    sicailLinksColor: '#000',
  },
  components: [
    {
      type: 'image',
      image: '1017/burger_1505312326850_1505312462526.png',
    },
    {
      type: 'image',
      image: 'em-email-images/CA-FR/QSR-Template-CA-FR.png',
    },
    {
      type: 'text',
      text: '<h2 class="ql-align-center" style="font-style:italic; color:#aa181c;">VENDREDI FRITES GRATUITES</h2>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">On adore les frites. Vous adorez les frites. Et on parie que vous aimerez encore plus des frites GRATUITES.</p>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">Commandez n’importe quel burger ou sandwich et recevez une grande frite gratuitement.</p>',
    },
    {
      type: 'spacer',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">Faites vite, l’offre est valide pour le mois de mars seulement!</p>',
    },
    {
      type: 'spacer',
    },
    {
      type: 'coupon',
      text: '<h3 class="ql-align-center" style="color:#aa181c;">GRANDE FRITE GRATUITE!</h3><p class="ql-align-center">(à l’achat de n’importe quel burger ou sandwich)</p><br><p class="ql-align-center" style="font-size: 10px;">Ne peut être jumelée à aucun autre coupon ou offre. Nul là où interdit. Taxes de vente en sus. Aucune valeur monétaire.</p>',
    },
    {
      type: 'divider',
    },
    {
      type: 'social',
      links: {
        facebook_link: 'https:www.facebook.com/',
        twitter_link: 'https:twitter.com/',
        youtube_link: 'https:www.youtube.com/',
      },
    },
  ],
};

const SushiEmailData = {
  styles: {
    width: '600px',
    color: '#fff',
    backgroundColor: '#231f20',
    couponBorderColor: '#fff',
    buttonsDividersColor: '#fff',
    sicailLinksColor: '#fff',
  },
  components: [
    {
      type: 'image',
      image: '472/sushi-email-logo_1498082220393.png',
    },
    {
      type: 'image',
      image: 'em-email-images/CA-FR/Sushi-Template-CA-FR.png',
    },
    {
      type: 'text',
      text: '<h2 class="ql-align-center" style="font-style:italic;">HEURE JOYEUSE À MOITIÉ PRIX!</h2>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">Sushis et entrées sélectionnés de 3,99 $ à 9,99 $!</p>',
    },
    {
      type: 'spacer',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">Découvrez aussi nos spéciaux sur les boissons et notre menu mis à jour.</p>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">Appelez à l’avance pour faire une réservation dès aujourd’hui!</p>',
    },
    {
      type: 'coupon',
      text: '<h4 class="ql-align-center">À L’ACHAT D’UN MAKI, OBTENEZ LE DEUXIÈME À MOITIÉ PRIX.</h4><p class="ql-align-center">(de valeur égale ou moindre)</p><br><p class="ql-align-center" style="font-size: 10px;">Limite d’une offre par client. Ne peut être jumelée à aucun autre coupon ou offre. Nul là où interdit. Taxes de vente en sus. Aucune valeur monétaire.</p>',
    },
    {
      type: 'divider',
    },
    {
      type: 'social',
      links: {
        facebook_link: 'https:www.facebook.com/',
        twitter_link: 'https:twitter.com/',
        youtube_link: 'https:www.youtube.com/',
      },
    },
  ],
};

const TimberlineEmailData = {
  styles: {
    width: '600px',
    color: '#000',
    backgroundColor: '#fff',
    sicailLinksColor: '#c58fbb',
    buttonsDividersColor: '#000',
  },
  components: [
    {
      type: 'social',
      links: {
        facebook_link: 'https:www.facebook.com/',
        twitter_link: 'https:twitter.com/',
        youtube_link: 'https:www.youtube.com/',
      },
    },
    {
      type: 'spacer',
    },
    {
      type: 'text',
      text: '<h1 class="ql-align-center" style="font-style:italic;">VENTE DE FIN D’ÉTÉ</h1>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">L’été tire à sa fin, mais on vous a réservé une dernière surprise.Cette semaine, à l’achat d’un article, obtenez-en un GRATUIT sur tout en magasin.</p>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center" style="font-style:italic; font-weight:bold;">Profitez de la vente!</p>',
    },
    {
      type: 'spacer',
    },
    {
      type: 'image',
      image: 'em-email-images/CA-FR/Timberline-Template-CA-FR.png',
    },
  ],
};

const BlankEmailData = {
  styles: {
    width: '600px',
    color: '#000',
    backgroundColor: '#fff',
    buttonsDividersColor: '#000',
    sicailLinksColor: '#000',
  },
  components: [
  ],
};

const AutomotiveServiceShopEmailData = {
  styles: {
    width: '600px',
    color: '#898989',
    backgroundColor: '#fff',
    couponBorderColor: '#00aeef',
    buttonsDividersColor: '#898989',
    sicailLinksColor: '#00aeef',
  },
  components: [
    {
      type: 'image',
      image: 'em-email-images/common/GP_550x300_29.%2BAutomotive%2BService%2BShops%2BTemplate.jpg',
    },
    {
      type: 'text',
      text: '<h2 class="ql-align-center">Stockage saisonnier gratuit de pneus!</h2>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">Obtenez une intervention le jour même pour la plupart des réparations automobiles.</p>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">Obtenez un devis clair et précis, sans frais cachés.</p>',
    },
    {
      type: 'coupon',
      text: '<h2 class="ql-align-center">Si vous achetez un nettoyage manuel de votre véhicule et un changement de pneus chez nous, nous entreposons vos pneus de saison gratuitement!</h2><p class="ql-align-center" style="font-size: 10px;">Non cumulable avec d&apos;autres coupons ou offres.</p>',
    },
    {
      type: 'divider',
    },
    {
      type: 'social',
        links: {
        facebook_link: 'https:www.facebook.com/',
          twitter_link: 'https:twitter.com/',
          youtube_link: 'https:www.youtube.com/',
      },
    },
  ],
};

const BarberShopEmailData = {
  styles: {
    width: '600px',
    color: '#898989',
    backgroundColor: '#fff',
    couponBorderColor: '#00aeef',
    buttonsDividersColor: '#898989',
    sicailLinksColor: '#00aeef',
  },
  components: [
    {
      type: 'image',
      image: 'em-email-images/common/GP_550x300_25.%2BBarber%2BShop%2BTemplate.jpg',
    },
    {
      type: 'text',
      text: '<h2 class="ql-align-center">Ensemble de soins complets maintenant avec 10% de rabais</h2>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">Installez-vous confortablement dans un fauteuil et confiez vos cheveux et votre barbe aux soins d&apos;un barbier professionnel. En plus d&apos;une coupe parfaite, vous pourrez savourer un café de qualité supérieure dans un environnement exclusivement masculin. Vous voulez un style plus pointu?</p>',
    },
    {
      type: 'coupon',
      text: '<h2 class="ql-align-center">Un forfait de soins complet, comprenant également un soin de la barbe, avec 10 % de rabais et un rhum de votre choix parmi nos rhums de première qualité offerts.</h2><p class="ql-align-center" style="font-size: 10px;">Non cumulable avec d&apos;autres coupons ou offres.</p>',
    },
    {
      type: 'divider',
    },
    {
      type: 'social',
        links: {
        facebook_link: 'https:www.facebook.com/',
          twitter_link: 'https:twitter.com/',
          youtube_link: 'https:www.youtube.com/',
      },
    },
  ],
};

const BeautyShopEmailData = {
  styles: {
    width: '600px',
    color: '#898989',
    backgroundColor: '#fff',
    couponBorderColor: '#00aeef',
    buttonsDividersColor: '#898989',
    sicailLinksColor: '#00aeef',
  },
  components: [
    {
      type: 'image',
      image: 'em-email-images/common/GP_550x300_26.%2BBeauty%2BShop%2BTemplate.jpg',
    },
    {
      type: 'text',
      text: '<h2 class="ql-align-center">Dépêchez-vous et obtenez 10% de rabais sur les cosmétiques naturels exclusifs</h2>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">Venez nous rendre visite pour vous détendre et vivre une expérience de changement à votre image. On va s&apos;occuper de vous de la tête aux pieds.</p>',
    },
    {
      type: 'coupon',
        text: '<h2 class="ql-align-center">En choisissant un soin esthétique dans notre salon, vous bénéficierez d&apos;un rabais de 10 % sur des cosmétiques naturels exclusifs.</h2><p class="ql-align-center" style="font-size: 10px;">Non cumulable avec d&apos;autres coupons ou offres.</p>',
    },
    {
      type: 'divider',
    },
    {
      type: 'social',
        links: {
        facebook_link: 'https:www.facebook.com/',
          twitter_link: 'https:twitter.com/',
          youtube_link: 'https:www.youtube.com/',
      },
    },
  ],
};

const ClothingShopEmailData = {
  styles: {
    width: '600px',
    color: '#898989',
    backgroundColor: '#fff',
    couponBorderColor: '#00aeef',
    buttonsDividersColor: '#898989',
    sicailLinksColor: '#00aeef',
  },
  components: [
    {
      type: 'image',
      image: 'em-email-images/common/GP_550x300_27.%2BClothing%2BStore%2BTemplate.jpg',
    },
    {
      type: 'text',
      text: '<h2 class="ql-align-center">Découvrez votre nouveau style</h2>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">Venez nous voir et laissez-vous inspirer. Cette semaine, on vous propose un article acheté, un autre offert dans toute la boutique.</p>',
    },
    {
      type: 'coupon',
      text: '<h2 class="ql-align-center">Ne peut être utilisé avec d&apos;autres coupons ou offres.</h2>',
    },
    {
      type: 'divider',
    },
    {
      type: 'social',
        links: {
        facebook_link: 'https:www.facebook.com/',
          twitter_link: 'https:twitter.com/',
          youtube_link: 'https:www.youtube.com/',
      },
    },
  ],
};

const FloristsEmailData = {
  styles: {
    width: '600px',
    color: '#898989',
    backgroundColor: '#fff',
    couponBorderColor: '#00aeef',
    buttonsDividersColor: '#898989',
    sicailLinksColor: '#00aeef',
  },
  components: [
    {
      type: 'image',
      image: 'em-email-images/common/GP_550x300_30.%2BFlorists%2BTemplate.jpg',
    },
    {
      type: 'text',
      text: '<h2 class="ql-align-center">L&apos;été est arrivé!</h2>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">Notre magasin s&apos;est paré d&apos;une robe d&apos;été! Comme chaque saison, nous avons aménagé nos locaux pour que vous puissiez voir et sentir l&apos;été. Venez vous inspirer et apporter un peu d&apos;été avec vous!</p>',
    },
    {
      type: 'coupon',
      text: '<h2 class="ql-align-center">Annuelles en pots seulement cette semaine avec 10% de réduction.</h2><p class="ql-align-center" style="font-size: 10px;">Non cumulable avec d&apos;autres coupons ou offres.</p>',
    },
    {
      type: 'divider',
    },
    {
      type: 'social',
        links: {
        facebook_link: 'https:www.facebook.com/',
          twitter_link: 'https:twitter.com/',
          youtube_link: 'https:www.youtube.com/',
      },
    },
  ],
};

const PetShopEmailData = {
  styles: {
    width: '600px',
    color: '#898989',
    backgroundColor: '#fff',
    couponBorderColor: '#00aeef',
    buttonsDividersColor: '#898989',
    sicailLinksColor: '#00aeef',
  },
  components: [
    {
      type: 'image',
      image: 'em-email-images/common/GP_550x300_28.%2BPet%2BShop%2BTemplate.jpg',
    },
    {
      type: 'text',
      text: '<h2 class="ql-align-center">Toujours un grand choix !</h2>',
    },
    {
      type: 'text',
      text: '<h2 class="ql-align-center">10% de rabais sur votre prochain achat</h2>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">Tout pour vos animaux, avec des conseils avisés.</p>',
    },
    {
      type: 'text',
      text: '<p class="ql-align-center">Vous pouvez acheter chez nous exactement ce dont votre animal a besoin.</p>',
    },
    {
      type: 'coupon',
      text: '<h2 class="ql-align-center">10% de rabais sur votre prochain achat</h2><p class="ql-align-center" style="font-size: 10px;">Non cumulable avec d&apos;autres coupons ou offres.</p>',
    },
    {
      type: 'divider',
    },
    {
      type: 'social',
        links: {
        facebook_link: 'https:www.facebook.com/',
          twitter_link: 'https:twitter.com/',
          youtube_link: 'https:www.youtube.com/',
      },
    },
  ],
};

export const frCaStaticTemplates = [
  {
    id: '4g64i88a5yd6cxb5gzko',
    crmid: '',
    name: '_i18n_StaticTemplates.StaticTemplateAutomotiveServiceShopTitle',
    status: 'origin',
    favorites: 'false',
    components: AutomotiveServiceShopEmailData.components,
    styles: AutomotiveServiceShopEmailData.styles,
    thumb: 'automotive-service-shop-email-preview-fr.png'
  },
  {
    id: '2or26236rrnh32hz7vuq',
    crmid: '',
    name: '_i18n_StaticTemplates.StaticTemplateBakeryTitle',
    status: 'origin',
    favorites: 'false',
    components: BakeryEmailData.components,
    styles: BakeryEmailData.styles,
    thumb: 'bakery-email-preview-ca-fr.png',
  },
  {
    id: 'f8u88e3r269b174lrccc',
    crmid: '',
    name: '_i18n_StaticTemplates.StaticTemplateBarberShopTitle',
    status: 'origin',
    favorites: 'false',
    components: BarberShopEmailData.components,
    styles: BarberShopEmailData.styles,
    thumb: 'barber-shop-email-preview-fr.png',
  },
  {
    id: '3ntzsgz6egu5gt36kv3q',
    crmid: '',
    name: '_i18n_StaticTemplates.StaticTemplateBarPubTitle',
    status: 'origin',
    favorites: 'false',
    components: BarPubEmailData.components,
    styles: BarPubEmailData.styles,
    thumb: 'bar-pub-email-preview-ca-fr.png',
  },
  {
    id: 'p3aaxcs047iycsvfllgj',
    crmid: '',
    name: '_i18n_StaticTemplates.StaticTemplateBeautyShopTitle',
    status: 'origin',
    favorites: 'false',
    components: BeautyShopEmailData.components,
    styles: BeautyShopEmailData.styles,
    thumb: 'beauty-shop-email-preview-fr.png',
  },
  {
    id: '70gtl79ctkr77w4wauof',
    crmid: '',
    name: '_i18n_StaticTemplates.StaticTemplateBurgerTitle',
    status: 'origin',
    favorites: 'false',
    components: BurgerEmailData.components,
    styles: BurgerEmailData.styles,
    thumb: 'burger-email-preview-ca-fr.png',
  },
  {
    id: '2dufgf4568eglhc9plxh',
    crmid: '',
    name: '_i18n_StaticTemplates.StaticTemplateChineseTitle',
    status: 'origin',
    favorites: 'false',
    components: ChineseEmailData.components,
    styles: ChineseEmailData.styles,
    thumb: 'chinese-email-preview-ca-fr.png',
  },
  {
    id: '63xi2lhyz5pzv67giql2',
    crmid: '',
    name: '_i18n_StaticTemplates.StaticTemplateClothingShopTitle',
    status: 'origin',
    favorites: 'false',
    components: ClothingShopEmailData.components,
    styles: ClothingShopEmailData.styles,
    thumb: 'clothing-shop-email-preview-fr.png',
  },
  {
    id: 'o0x3qfxwatisc0agvmd8',
    crmid: '',
    name: '_i18n_StaticTemplates.StaticTemplateCoffeeTitle',
    status: 'origin',
    favorites: 'false',
    components: CoffeeEmailData.components,
    styles: CoffeeEmailData.styles,
    thumb: 'coffee-email-preview-ca-fr.png',
  },
  {
    id: 'd2660h7r2lorgeyhrx6b',
    crmid: '',
    name: '_i18n_StaticTemplates.StaticTemplateDessertTitle',
    status: 'origin',
    favorites: 'false',
    components: DessertEmailData.components,
    styles: DessertEmailData.styles,
    thumb: 'dessert-email-preview-ca-fr.png',
  },
  {
    id: 'm5ob2n9kacxtffusb8ck',
    crmid: '',
    name: '_i18n_StaticTemplates.StaticTemplateDinerTitle',
    status: 'origin',
    favorites: 'false',
    components: DinerEmailData.components,
    styles: DinerEmailData.styles,
    thumb: 'diner-email-preview-ca-fr.png',
  },
  {
    id: '9hw3q4o8f3dnbzk2tpcs',
    crmid: '',
    name: '_i18n_StaticTemplates.StaticTemplateFamilyDiningTitle',
    status: 'origin',
    favorites: 'false',
    components: FamilyDiningEmailData.components,
    styles: FamilyDiningEmailData.styles,
    thumb: 'family-dining-email-preview-ca-fr.png',
  },
  {
    id: 'bm1f7lho6b77jhsm0f1b',
    crmid: '',
    name: '_i18n_StaticTemplates.StaticTemplateFineDiningTitle',
    status: 'origin',
    favorites: 'false',
    components: FineDiningEmailData.components,
    styles: FineDiningEmailData.styles,
    thumb: 'fine-dining-email-preview-ca-fr.png',
  },
  {
    id: 'i08fvwvhytzcrkndskdp',
    crmid: '',
    name: '_i18n_StaticTemplates.StaticTemplateFloristsTitle',
    status: 'origin',
    favorites: 'false',
    components: FloristsEmailData.components,
    styles: FloristsEmailData.styles,
    thumb: 'florists-email-preview-fr.png',
  },
  {
    id: '8778dy1linh95ebeo35y',
    crmid: '',
    name: '_i18n_StaticTemplates.StaticTemplateFruitTitle',
    status: 'origin',
    favorites: 'false',
    components: FruitEmailData.components,
    styles: FruitEmailData.styles,
    thumb: 'fruit-email-preview-ca-fr.png',
  },
  {
    id: 'wd2ht0kwm61uhwecf81k',
    crmid: '',
    name: '_i18n_StaticTemplates.StaticTemplateItalianTitle',
    status: 'origin',
    favorites: 'false',
    components: ItalianEmailData.components,
    styles: ItalianEmailData.styles,
    thumb: 'italian-email-preview-ca-fr.png',
  },
  {
    id: 'ih68rtqyjdn81arz9hbo',
    crmid: '',
    name: '_i18n_StaticTemplates.StaticTemplateMexicanTitle',
    status: 'origin',
    favorites: 'false',
    components: MexicanEmailData.components,
    styles: MexicanEmailData.styles,
    thumb: 'mexican-email-preview-ca-fr.png',
  },
  {
    id: 'yea5u921ve2wwod97nwd',
    crmid: '',
    name: '_i18n_StaticTemplates.StaticTemplateMoveItSportsTitle',
    status: 'origin',
    favorites: 'false',
    components: MoveItSportsEmailData.components,
    styles: MoveItSportsEmailData.styles,
    thumb: 'move-it-sports-email-preview-ca-fr.png',
  },
  {
    id: '71xrlsj735mlbfzsel7q',
    crmid: '',
    name: '_i18n_StaticTemplates.StaticTemplatePetShopTitle',
    status: 'origin',
    favorites: 'false',
    components: PetShopEmailData.components,
    styles: PetShopEmailData.styles,
    thumb: 'pet-shop-email-preview-fr.png'
  },
  {
    id: 'jc9g5uxfj9b2z1177i1j',
    crmid: '',
    name: '_i18n_StaticTemplates.StaticTemplatePizzaTitle',
    status: 'origin',
    favorites: 'false',
    components: PizzaEmailData.components,
    styles: PizzaEmailData.styles,
    thumb: 'pizza-email-preview-ca-fr.png',
  },
  {
    id: 'rrurh9rjqo2fg1ew17i5',
    crmid: '',
    name: '_i18n_StaticTemplates.StaticTemplateQSRTitle',
    status: 'origin',
    favorites: 'false',
    components: QsrEmailData.components,
    styles: QsrEmailData.styles,
    thumb: 'qsr-email-preview-ca-fr.png',
  },
  {
    id: 'wdc7wpdkj5mnvrsurcm1',
    crmid: '',
    name: '_i18n_StaticTemplates.StaticTemplateSushiTitle',
    status: 'origin',
    favorites: 'false',
    components: SushiEmailData.components,
    styles: SushiEmailData.styles,
    thumb: 'sushi-email-preview-ca-fr.png',
  },
  {
    id: 'ssdy3o1vk7cfxu9fg52g',
    crmid: '',
    name: '_i18n_StaticTemplates.StaticTemplateTimberlineTitle',
    status: 'origin',
    favorites: 'false',
    components: TimberlineEmailData.components,
    styles: TimberlineEmailData.styles,
    thumb: 'timberline-email-preview-ca-fr.png',
  },
  {
    id: 'kem3qb5keay31jnvzpk1',
    crmid: '',
    name: '_i18n_StaticTemplates.StaticTemplateBlankTitle',
    status: 'origin',
    favorites: 'false',
    components: BlankEmailData.components,
    styles: BlankEmailData.styles,
    thumb: 'blank-ca-fr.png',
  },
];
